import Common from "../../Common";
import { TtsPlayBody } from "../company/pbx/soundfile/Tts";

const Tts = class extends Common {
	generate = (body: TtsPlayBody, userId?: id): CustomResponse<{ sound_id: string, }> =>
		this.post(
			`/sound/tts/generate` + (userId ? `/${userId}` : ''),
			{
				...body,
				tts_rate: body.tts_rate ?? null,
				tts_pitch: body.tts_pitch ?? null,
			}
		)

	download = (soundGuid: string): CustomResponse<Blob> =>
		this.get(
			`/sound/tts/${soundGuid}/download`,
			{},
			{
				responseType: 'blob',
			}
		)
}

export default Tts
